import { Component, OnInit } from '@angular/core';
import { PrintService } from '../../services/print.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'print-story',
  styleUrls: ['../wizard/wizard.component.scss', './print.component.scss'],
  templateUrl: './print.component.html',
})
export class PrintStoryComponent implements OnInit {
  public step = 1;
  public totalSteps = 5;
  public paymentStepView;

  constructor(
    private printService: PrintService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.printService.initializeWizard();
    this.printService.initBraintree();
  }

  nextStep = () => {
    this.setStep(this.step + 1);
  };

  prevStep = () => {
    this.setStep(this.step - 1);
  };

  setStep = step => {
    window.scrollTo(0, 0);
    this.step = step;
  };

  isFooterHidden() {
    return (
      (this.step === 4 && this.paymentStepView === 'add') || this.step === 6
    );
  }

  setPaymentStepView = view => {
    window.scrollTo(0, 0);
    this.paymentStepView = view;
  };

  submit() {
    this.nextStep();
  }

  onPromocodeActivated(code) {
    const storyId = this.activatedRoute.snapshot.params.id;
    this.printService.getBookformatsWithFallback(storyId, code).subscribe();
    if (this.printService.printOrder.id) {
      this.printService.applyDiscount(code).subscribe();
    }
  }
}
